import { TShirtSize } from './sizing'
import { exhaustive } from './type-assertions'

export const sizeToFontSize = (size: TShirtSize) => {
  switch (size) {
    case 'extra-small':
      return 'text-xs'
    case 'small':
      return 'text-sm'
    case 'medium':
      return 'text-md'
    case 'large':
      return 'text-xl'
    case 'extra-large':
      return 'text-2xl '
    default:
      exhaustive(size)
  }
}
